export var TourType;
(function (TourType) {
    TourType["EXERCISE_LIBRARY_TOUR"] = "EXERCISE_LIBRARY_TOUR";
    TourType["OFFICE_MGM_TOUR"] = "OFFICE_MGM_TOUR";
    TourType["OFFICE_PROFILE_SETTINGS_TOUR"] = "OFFICE_PROFILE_SETTINGS_TOUR";
    TourType["OFFICE_SHOP_TOUR"] = "OFFICE_SHOP_TOUR";
    TourType["VIDEO_CALL_TOUR"] = "VIDEO_CALL_TOUR";
})(TourType || (TourType = {}));
//# sourceMappingURL=tour.enum.js.map